import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import SEO from '@/components/common/SEO';
import Spinner from '@/components/common/Spinner';

function RootRedirector() {
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth();

  const seo = (
    <SEO
      title="Fantasy Futbol | Fantasy Football Draft Leagues for EPL & La Liga"
      description="Season-long fantasy draft leagues for the Premier League and La Liga, plus daily salary-cap contests - the fantasy football experience, for soccer."
      path="/"
    />
  );

  if (isAuthLoading) {
    return (
      <>
        {seo}
        <div className="flex justify-center items-center h-screen bg-primary">
          <Spinner size="lg" color="text-accent-yellow" />
        </div>
      </>
    );
  }

  // `/` is the state-aware app entry. Signed-out visitors keep the public
  // football-comparison experience; signed-in users enter their personal HQ.
  return (
    <>
      {seo}
      <Navigate to={isAuthenticated ? '/home' : '/contests'} replace />
    </>
  );
}

export default RootRedirector;
